/**
 * Created by ricardocabret on 8/10/16.
 */
angular.module('eStories.uploader.model', [

        /*Uploader Model*/

    ])
    .service('UploadModel', [ '$rootScope', function ($rootScope) {
        var model = this;

        model.uploadInProgress = false;
        model.fileCount = 0;
        model.totalProgressPercent = 0;
        model.totalUploadProgress = 0;
        model.filesCompleted = 0;

        model.resetUploader = function () {
            model.uploadInProgress = false;
            model.fileCount = 0;
            model.totalProgressPercent = 0;
            model.totalUploadProgress = 0;
            model.filesCompleted = 0
        };

        model.getUploadProgressPercent = function () {
            if (!model.totalProgressPercent) {
                return;
            }
            return {width: model.totalProgressPercent + '%'}
        };


    }])

    .directive('dropzone', [
        'UploadModel',
        '$rootScope',
        '$timeout',
        'LL',
        'ModalsModel',
        '$state',
        function (UploadModel, $rootScope, $timeout, LL, ModalsModel, $state) {

            return {
                restrict: 'C',
                scope: {
                    uploadUrl: '@'
                },

                link: function (scope, element, attrs) {

                    var config = {
                        url: scope.uploadUrl,
                        maxFilesize: 1000,
                        paramName: "file",
                        maxThumbnailFilesize: 10,
                        parallelUploads: 1,
                        autoProcessQueue: true,
                        acceptedFiles: '.mp3, .m4b',
                        clickable: true
                    };

                    var eventHandlers = {



                        'addedfile': function (file) {
                            scope.file = file;
                            UploadModel.forceUploadCancel = false;
                            scope.$apply(function () {
                                UploadModel.fileCount = this.files.length;
                                UploadModel.uploadInProgress = true;
                            }.bind(this));
                            var llObj = {
                                FileType: file.type
                            };
                            if ($state.current.name == 'eStories.navbars.upload') {
                                UploadModel.alreadyShowingUploadConfirmation = false;
                                ModalsModel.open('/uploader/uploadModal.tmpl.html', 'UploadCtrl', 'uploadCtrl');
                            }
                            LL.tagEvent('Start Upload', llObj);
                        },

                        'uploadprogress': function (file, progress) {
                            var a = ((UploadModel.filesCompleted * 100) + progress) / UploadModel.fileCount;
                            UploadModel.totalProgressPercent = Math.round(a * 10) / 10 == 100 ? 99 : Math.round(a * 10) / 10;
                            UploadModel.totalUploadProgress = Math.floor(a) == 100 ? 99 : Math.floor(a);
                            scope.$apply();
                        },

                        'success': function (file, response) {
//                            NOT first time through
                            var llObj = {
                                FileType: file.type,
                                Response: response
                            };

                            if (response.responseStatus == 'FAILED') {
                                llObj.Response.type = response.responseText;
                                llObj.Response.status = "failure";
                                LL.tagEvent('Complete Upload', llObj);
                                if (!UploadModel.failedFiles) {
                                    UploadModel.failedFiles = 1
                                } else {
                                    UploadModel.failedFiles += 1
                                }
                            } else if (response.responseStatus == 'SUCCESS') {
                                llObj.Response.status = "success";
                                LL.tagEvent('Complete Upload', llObj);
                                if (!UploadModel.successfulFiles) {
                                    UploadModel.successfulFiles = 1
                                } else {
                                    UploadModel.successfulFiles += 1
                                }
                            }
                        },

                        'complete': function () {
                            if (!UploadModel.forceUploadCancel) {
                                UploadModel.filesCompleted++;
                            }
                        },

                        'error': function (file, errorMessage, c) {
                        },

                        'queuecomplete': function () {
                            if (!UploadModel.forceUploadCancel) {
                                UploadModel.totalProgressPercent = 100;
                                UploadModel.totalUploadProgress = 100;

                                scope.$apply(function () {
                                    $rootScope.$broadcast('uploadComplete');
                                });
                            }
                        }
                    };

                    var dropzone = UploadModel.dropzone = new Dropzone(element[0], config);

                    angular.forEach(eventHandlers, function (handler, event) {
                        dropzone.on(event, handler);
                    });

                    $rootScope.$on('resetDropzone', function (e) {
                        UploadModel.forceUploadCancel = true;
                        UploadModel.resetUploader();
                        dropzone.removeAllFiles();
                    });
                }
            }
        }]);